/* Phase 2 primitive: the one HMS status chip.
 *
 * The same ten document states (draft ... voided) are re-styled by hand
 * on the invoicing, contracts and delivery screens. This is that chip,
 * once, so a state always looks the same wherever it appears.
 *
 * Props:
 *  - status:   'draft' | 'pending' | 'pendingConversion' | 'rejected'
 *              | 'approved' | 'sent' | 'paid' | 'overdue' | 'cancelled'
 *              | 'voided'
 *  - priority: 'high' | 'normal'  — the solid to-do/priority chip, used
 *              instead of `status`
 *  - children: the label; the caller owns the wording so a screen can
 *              say "Awaiting approval" over the `pending` tone
 *  - className: extra hook
 *
 * An unknown (or omitted) tone falls back to the neutral base chip
 * rather than rendering nothing.
 */
import React from 'react';
import './HMSBadge.css';

// Prop values stay camelCase (JS side), class names stay kebab (CSS side).
const STATUS_CLASS = {
  draft: 'hms-badge-draft',
  pending: 'hms-badge-pending',
  pendingConversion: 'hms-badge-pending-conversion',
  rejected: 'hms-badge-rejected',
  approved: 'hms-badge-approved',
  sent: 'hms-badge-sent',
  paid: 'hms-badge-paid',
  overdue: 'hms-badge-overdue',
  cancelled: 'hms-badge-cancelled',
  voided: 'hms-badge-voided',
};

const PRIORITY_CLASS = {
  high: 'hms-badge-priority-high',
  normal: 'hms-badge-priority-normal',
};

const HMSBadge = ({ status, priority, children, className = '' }) => {
  const cls = [
    'hms-badge',
    (status && STATUS_CLASS[status]) || (priority && PRIORITY_CLASS[priority]) || '',
    className,
  ].filter(Boolean).join(' ');

  return <span className={cls}>{children}</span>;
};

export default HMSBadge;
